import Background from './components/Background';
import Container from './components/Container';

function App() {
    return (
        <main>
            <Background />
            <Container>
                <h1>AccRobotics</h1>
                <div className="tagline">Robotics, Accelerated</div>
                <div className="stealth">
                    We are currently in stealth. Stay tuned for more.
                </div>
            </Container>
        </main>
    );
}

export default App; 